import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { selectCatalogingOnSiteEnabled } from '../../../catalog/selectors/CatalogSelectors';
import { contentCountsRequest } from '../../actions/spaces/ContentCountsActions';
import { selectContentCounts, selectContentCountsUpToDate } from '../../selectors/ContentCountsSelector';
import { selectMixedContentFilterClauses, selectSearchText } from '../../selectors/ContentFilterSelectors';
import { CompositeSessionInfoSelectors } from '../../selectors/SessionInfoSelectors';
import { siteUrlsSelector } from '../../selectors/SiteUrlsSelectors';
import { AppState } from '../../state/AppState';
import { MapDispatchToProps, MapStateToProps } from '../../utils/ConnectUtils';
import { SearchSpace, SearchSpaceDispatchProps, SearchSpaceOwnProps, SearchSpaceStateProps } from './SearchSpace';

const mapStateToProps: MapStateToProps<SearchSpaceStateProps> = (state: AppState) => ({
  urls: siteUrlsSelector(state),
  searchTerm: selectSearchText(state),
  contentFilters: selectMixedContentFilterClauses(state),
  contentCounts: selectContentCounts<'search'>(state, 'search'),
  contentCountsUptoDate: selectContentCountsUpToDate(state),
  catalogingOnSiteEnabled: selectCatalogingOnSiteEnabled(state),
  areUsersVisible: !CompositeSessionInfoSelectors.isLimitedUserVisibilityEnforced(state)
});

const mapDispatchToProps: MapDispatchToProps<SearchSpaceDispatchProps> =
  (dispatch) => bindActionCreators({
    fetchUpdatedContentCounts: contentCountsRequest
  },
  dispatch);

export const ConnectedSearchSpace: React.ComponentClass<SearchSpaceOwnProps>
  = connect(mapStateToProps, mapDispatchToProps)(SearchSpace);
